module.exports = __webpack_public_path__ + "static/stage-d5e5b5215e6821c0b5ec25e69f4b7a86.jpg";